import { faLock } from '@fortawesome/pro-solid-svg-icons/faLock'
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle'
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle'
import { BlockStatus } from 'enum/block-status.enum'

const translationPrefix = 'reusables.blockBanner'

const options = {
  [BlockStatus.Pending]: {
    prefix: '',
    title: `${translationPrefix}.pending.title`,
    icon: faLock,
  },
  [BlockStatus.InProgress]: {
    prefix: `${translationPrefix}.inProgress.prefix`,
    title: `${translationPrefix}.inProgress.title`,
    icon: faExclamationTriangle,
  },
  [BlockStatus.Finish]: {
    prefix: `${translationPrefix}.finish.prefix`,
    title: `${translationPrefix}.finish.title`,
    icon: faCheckCircle,
  },
}

export default options
